// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"c2083393","175":"577fb030","248":"7d7333a4","305":"cb377b81","447":"03f939d1","531":"938fcb75","899":"43ffd981","952":"2f3c2336","965":"9e93cd56"}[chunkId] + ".chunk.js";
};